module.exports = __webpack_public_path__ + "static/tarifs-210450837d91e610e51aeae87e10fd88.jpg";